import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen grid place-items-center bg-alabaster px-4">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-white border border-[#E2E4DC] p-10 sm:p-12"
      >
        <div className="flex items-center gap-3 mb-3">
          <KeyRound size={18} className="text-gold" />
          <p className="overline-label">Área Reservada</p>
        </div>
        <h1 className="font-serif text-2xl sm:text-3xl font-semibold text-ebony mb-10">
          Gestão de conteúdos
        </h1>

        <label className="overline-label block mb-2 !text-[10px]" htmlFor="ad-email">Email</label>
        <input
          id="ad-email"
          data-testid="admin-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-field mb-6"
          placeholder="admin@…"
          autoComplete="username"
        />
        <label className="overline-label block mb-2 !text-[10px]" htmlFor="ad-pass">Palavra-passe</label>
        <input
          id="ad-pass"
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input-field mb-8"
          placeholder="••••••••"
          autoComplete="current-password"
        />

        {error && (
          <p data-testid="admin-login-error" className="text-sm text-[#A33B2E] bg-[#A33B2E]/5 border border-[#A33B2E]/20 px-4 py-3 mb-6">
            {error}
          </p>
        )}

        <button
          type="submit"
          data-testid="admin-login-submit-button"
          disabled={loading}
          className="btn-primary w-full disabled:opacity-60"
        >
          {loading ? "A entrar…" : "Entrar"}
        </button>
      </form>
    </main>
  );
}
